import { render, staticRenderFns } from "./areaRemove.vue?vue&type=template&id=acc6402c&scoped=true"
import script from "./areaRemove.vue?vue&type=script&lang=js"
export * from "./areaRemove.vue?vue&type=script&lang=js"
import style0 from "./areaRemove.vue?vue&type=style&index=0&id=acc6402c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc6402c",
  null
  
)

export default component.exports